import React from "react";
import { array, string } from "prop-types";
import { Link } from "@quintype/components";

import "./staticFooterLinks.m.css";

const StaticFooterLinks = ({ links, className }) => (
  <div styleName="wrapper" className={className}>
    {links.map(
      (item, index) =>
        item.isExternalLink ? (
          <a href={item.completeUrl} key={index} styleName="static-links" target="_blank" rel="noopener noreferrer">
            {item.title}
          </a>
        ) : (
          <Link href={item.completeUrl} key={index} styleName="static-links">
            {item.title}
          </Link>
        )
    )}
  </div>
);

StaticFooterLinks.propTypes = {
  links: array,
  className: string
};

export default StaticFooterLinks;
